import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewCyclesActions from './review-cycles.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewCyclesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewCyclesActions.ReviewCyclesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_CYCLES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewCyclesActions.ReviewCyclesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewCyclesActions.ReviewCyclesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewCyclesActions.ReviewCyclesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewCyclesActions.ReviewCyclesRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new ReviewCyclesActions.ReviewsCyclesRefreshById(data.id));
          break;
      }
    });
  }
}
